import { useContext } from 'react';
import { ServicesCartContext } from '@context';

export const useServicesCart = () => {
    const context = useContext(ServicesCartContext);
    if (!context) {
        throw new Error('useServicesCart must be used within a ServicesCartProvider');
    }
    return context;
};
